// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__147Wg","header":"ClearentDisclaimer_header__2wx2R","inner":"ClearentDisclaimer_inner__33whd"};